import * as React from "react";

import {GuideColors} from "../guide-colors.ts";

interface Props {
    id: string;
    isOffline: boolean;
    title?: string;
}

export const PopoverGuideIcon = (props: Props): React.ReactElement => {
    const swagId = props.isOffline ? "offline" : props.id;
    switch (swagId) {
        case "baseball-cap":
            return <BaseballCapGuideIcon title={props.title} />;
        case "sunglasses":
            return <SunglassesGuideIcon title={props.title} />;
        case "fedora":
            return <FedoraGuideIcon title={props.title} />;
        case "fedora-shiny":
            return <FedoraShinyGuideIcon title={props.title} />;
        case "headphones":
            return <HeadphonesGuideIcon title={props.title} />;
        case "beanie-and-scarf":
            return <BeanieAndScarfGuideIcon title={props.title} />;
        case "crown":
            return <CrownGuideIcon title={props.title} />;
        case "bucket-hat":
            return <BucketHatGuideIcon title={props.title} />;
        case "graduation-cap":
            return <GraduationCapGuideIcon title={props.title} />;
        case "glasses":
            return <GlassesGuideIcon title={props.title} />;
        case "cowboy-hat":
            return <CowboyHatGuideIcon title={props.title} />;
        case "beret":
            return <BeretGuideIcon title={props.title} />;
        case "party-hat":
            return <PartyHatGuideIcon title={props.title} />;
        case "reindeer":
            return <ReindeerGuideIcon title={props.title} />;
        case "offline":
            return <OfflineGuideIcon title={props.title} />;
        case "default":
        default:
            return <DefaultGuideIcon title={props.title} />;
    }
};

const DefaultGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 12.88H38.45C41.22 12.88 43.47 15.13 43.47 17.89V40.57C43.47 42.76 40.86 43.90 39.25 42.41L37.57 40.85C37.10 40.42 36.49 40.18 35.86 40.18H15.11C13.72 40.18 12.60 39.05 12.60 37.67V17.89C12.60 15.13 14.85 12.88 17.61 12.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4178" cy="27.8582" r="6.01791" fill="white" />
        <mask
            id="mask0_3076_150593"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="21"
            width="13"
            height="13"
        >
            <circle cx="21.4178" cy="27.8582" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_3076_150593)">
            <circle cx="17.22" cy="23.673" r="5.46" fill="black" />
        </g>
        <circle cx="34.578" cy="27.8579" r="6.01791" fill="white" />
        <mask
            id="mask1_3076_150593"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="21"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="27.8579" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_3076_150593)">
            <circle cx="30.3802" cy="23.6728" r="5.46" fill="black" />
        </g>
    </svg>
);

const BaseballCapGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M21.75 11.80H33.44C39.34 11.80 44.13 16.59 44.13 22.49V41.47C44.13 43.82 41.33 45.04 39.61 43.44L37.80 41.76C37.31 41.30 36.65 41.05 35.98 41.05H13.74C12.26 41.05 11.05 39.84 11.05 38.36V22.49C11.05 16.59 15.84 11.80 21.75 11.80Z"
            fill="#DEAE93"
        />
        <path
            d="M11.05 19.05C11.05 13.81 15.30 9.56 20.55 9.56H34.73C39.97 9.56 44.22 13.81 44.22 19.05H11.05Z"
            fill="#5BA26F"
        />
        <path
            d="M31.11 13.26C29.29 13.27 27.82 14.79 27.82 16.67V16.75H27.68V16.67C27.68 14.79 26.20 13.27 24.38 13.26C24.37 13.38 24.36 13.50 24.36 13.62C24.36 15.09 25.27 16.34 26.53 16.82C26.92 16.97 27.33 17.04 27.75 17.04C28.16 17.04 28.57 16.97 28.96 16.82C30.22 16.34 31.13 15.09 31.13 13.62C31.13 13.50 31.12 13.38 31.11 13.26Z"
            fill="white"
        />
        <path
            d="M28.51 13.16C28.93 12.74 28.93 12.06 28.51 11.64C28.09 11.21 27.40 11.21 26.98 11.64C26.56 12.06 26.56 12.74 26.98 13.16C27.40 13.59 28.09 13.59 28.51 13.16Z"
            fill="white"
        />
        <path d="M7.13 19.16H44.22" stroke="#3A644B" strokeWidth="2.18182" />
        <path
            d="M25.89 9.56C25.89 8.84 26.48 8.25 27.20 8.25H28.07C28.80 8.25 29.38 8.84 29.38 9.56H25.89Z"
            fill="#3A644B"
        />
        <ellipse
            cx="20.6311"
            cy="29.5344"
            rx="6.05787"
            ry="6.05787"
            fill="white"
        />
        <mask
            id="mask0_14058_14949"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="14"
            y="23"
            width="13"
            height="13"
        >
            <ellipse
                cx="20.6311"
                cy="29.5344"
                rx="6.05787"
                ry="6.05787"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0_14058_14949)">
            <ellipse
                cx="15.9825"
                cy="27.154"
                rx="6.2009"
                ry="6.2009"
                fill="black"
            />
        </g>
        <ellipse
            cx="33.9421"
            cy="29.5344"
            rx="6.05787"
            ry="6.05787"
            fill="white"
        />
        <mask
            id="mask1_14058_14949"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="27"
            y="23"
            width="13"
            height="13"
        >
            <ellipse
                cx="33.9421"
                cy="29.5344"
                rx="6.05787"
                ry="6.05787"
                fill="white"
            />
        </mask>
        <g mask="url(#mask1_14058_14949)">
            <ellipse
                cx="29.2936"
                cy="27.154"
                rx="6.2009"
                ry="6.2009"
                fill="black"
            />
        </g>
    </svg>
);

const SunglassesGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_26809"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_26809)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_26809"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_26809)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M26.47 27.15V27.15C27.35 26.90 28.29 26.90 29.17 27.15V27.15"
            stroke="black"
            strokeWidth="3.14685"
        />
        <circle
            cx="20.7277"
            cy="28.9547"
            r="4.43649"
            stroke="black"
            strokeWidth="4.55405"
        />
        <rect
            x="13"
            y="26.4297"
            width="3.35664"
            height="2.72727"
            fill="black"
        />
        <rect
            x="39.6433"
            y="26.4297"
            width="3.35664"
            height="2.72727"
            fill="black"
        />
        <circle
            cx="20.7277"
            cy="28.9547"
            r="4.43649"
            fill="black"
            stroke="black"
            strokeWidth="4.55405"
        />
        <path
            d="M24.26 23.88L14.45 29.55"
            stroke="#F4EEE2"
            strokeWidth="1.67832"
        />
        <circle
            cx="20.7277"
            cy="28.9547"
            r="6.11951"
            stroke="black"
            strokeWidth="1.18801"
        />
        <circle
            cx="35.2373"
            cy="28.9547"
            r="4.43649"
            fill="black"
            stroke="black"
            strokeWidth="4.55405"
        />
        <path
            d="M38.77 23.88L28.96 29.55"
            stroke="#F4EEE2"
            strokeWidth="1.67832"
        />
        <circle
            cx="35.2373"
            cy="28.9547"
            r="6.11951"
            stroke="black"
            strokeWidth="1.18801"
        />
    </svg>
);

const FedoraGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M12.6 22.88H43.47V43.57C43.47 45.76 40.86 46.90 39.25 45.41L37.57 43.85C37.10 43.42 36.49 43.18 35.86 43.18H15.11C13.72 43.18 12.6 42.05 12.6 40.67V22.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="30.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_26859"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="24"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="30.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_26859)">
            <circle cx="16.8" cy="28.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="30.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_26859"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="24"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="30.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_26859)">
            <circle cx="29.96" cy="28.492" r="6.16" fill="black" />
        </g>
        <path d="M9 23.20H47" stroke="black" strokeWidth="2.11111" />
        <path d="M9 23.20H47" stroke="black" strokeWidth="2.11111" />
        <path
            d="M16.97 13.31L13.01 22.14H43.41L42.38 15.49C41.79 11.69 37.77 9.46 34.23 10.96L30.38 12.59C30.28 12.63 30.16 12.63 30.05 12.59L24.69 10.29C21.73 9.02 18.29 10.36 16.97 13.31Z"
            fill="black"
            stroke="black"
            strokeWidth="1.05556"
            strokeLinecap="square"
            strokeLinejoin="round"
        />
        <mask
            id="mask2_14505_26859"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="12"
            y="9"
            width="32"
            height="14"
        >
            <path
                d="M16.97 13.31L13.01 22.14H43.41L42.38 15.49C41.79 11.69 37.77 9.46 34.23 10.96L30.38 12.59C30.28 12.63 30.16 12.63 30.05 12.59L24.69 10.29C21.73 9.02 18.29 10.36 16.97 13.31Z"
                fill="black"
                stroke="black"
                strokeWidth="1.05556"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </mask>
        <g mask="url(#mask2_14505_26859)">
            <rect
                x="12.1666"
                y="19.1885"
                width="32.7222"
                height="2.95556"
                fill="#F4EEE2"
            />
        </g>
    </svg>
);

const HeadphonesGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_27302"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_27302)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_27302"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_27302)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M13.02 25.45V19.54C13.02 15.93 15.95 13 19.56 13H36.44C40.05 13 42.98 15.93 42.98 19.54V25.45"
            stroke="#BED5FF"
            strokeWidth="3.37615"
        />
        <path
            d="M5 27.14C5 30.40 7.65 33.05 10.91 33.05V21.23C7.65 21.23 5 23.87 5 27.14Z"
            fill="#BED5FF"
        />
        <rect
            x="10.6973"
            y="19.9629"
            width="4.00918"
            height="14.1376"
            rx="1.26606"
            fill="#1865F2"
        />
        <path
            d="M51 27.14C51 30.40 48.35 33.05 45.09 33.05V21.23C48.35 21.23 51 23.87 51 27.14Z"
            fill="#BED5FF"
        />
        <rect
            width="4.00918"
            height="14.1376"
            rx="1.26606"
            transform="matrix(-1 0 0 1 45.3027 19.9629)"
            fill="#1865F2"
        />
    </svg>
);

const BeanieAndScarfGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M46.03 35.96L49.00 36.75"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M45.62 37.51L48.58 38.30"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M45.17 39.16L48.14 39.96"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M44.73 40.82L47.70 41.61"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <rect
            width="11.9264"
            height="5.82799"
            rx="0.602895"
            transform="matrix(-0.965926 -0.258819 -0.258819 0.965926 47.7423 36.0059)"
            fill="#AC4343"
        />
        <path
            d="M46.03 34.94L49.00 34.15"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M45.62 33.39L48.58 32.60"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M45.17 31.74L48.14 30.94"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <path
            d="M44.73 30.09L47.70 29.29"
            stroke="#FCB500"
            strokeWidth="0.80386"
            strokeLinecap="square"
        />
        <rect
            x="47.7423"
            y="34.8945"
            width="11.9264"
            height="5.82799"
            rx="0.602895"
            transform="rotate(165 47.7423 34.8945)"
            fill="#AC4343"
        />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_27515"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_27515)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_27515"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_27515)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M12.63 20.23C12.63 14.60 17.19 10.05 22.81 10.05H33.40C39.02 10.05 43.57 14.60 43.57 20.23H12.63Z"
            fill="#FCB500"
        />
        <mask
            id="mask2_14505_27515"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="12"
            y="10"
            width="32"
            height="11"
        >
            <path
                d="M12.63 20.23C12.63 14.60 17.19 10.05 22.81 10.05H33.40C39.02 10.05 43.57 14.60 43.57 20.23H12.63Z"
                fill="#FCB500"
            />
        </mask>
        <g mask="url(#mask2_14505_27515)">
            <path
                d="M12.22 16.97H43.98"
                stroke="#F46A37"
                strokeWidth="1.42515"
            />
        </g>
        <rect
            x="11"
            y="17.5801"
            width="34"
            height="5.49701"
            rx="1.62874"
            fill="#FCB500"
        />
        <path d="M25.25 9.84H31.36" stroke="#F46A37" strokeWidth="1.01796" />
        <path
            d="M28.31 6.79L28.31 12.90"
            stroke="#F46A37"
            strokeWidth="1.01796"
        />
        <path
            d="M26.15 7.68L30.46 12.00"
            stroke="#F46A37"
            strokeWidth="1.01796"
        />
        <path
            d="M30.46 7.68L26.15 12.00"
            stroke="#F46A37"
            strokeWidth="1.01796"
        />
        <path
            d="M15.07 23.08L15.07 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <path
            d="M20.37 23.08L20.37 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <path
            d="M25.46 23.08L25.46 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <path
            d="M30.75 23.08L30.75 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <path
            d="M35.84 23.08L35.84 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <path
            d="M41.13 23.08L41.13 17.58"
            stroke="#F46A37"
            strokeWidth="1.42515"
        />
        <rect
            x="11.4021"
            y="36.1377"
            width="32.5563"
            height="5.82799"
            rx="0.602895"
            fill="#F46A37"
        />
    </svg>
);

const CrownGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_27820"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_27820)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_27820"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_27820)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M23.33 9.35L22.01 13.93C23.97 15.15 25.81 13.96 26.49 13.22L23.33 9.35Z"
            fill="#F28D31"
        />
        <path
            d="M33.11 9.35L34.43 13.93C32.48 15.15 30.63 13.96 29.95 13.22L33.11 9.35Z"
            fill="#F28D31"
        />
        <circle cx="23.4363" cy="9.14513" r="1.01818" fill="#F28D31" />
        <circle cx="33.2108" cy="9.14513" r="1.01818" fill="#F28D31" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.24 9.78L23.35 13.89L28.12 9.13H28.12L32.89 13.89L37.22 9.56V17.83C37.22 18.17 36.95 18.44 36.61 18.44H19.85C19.51 18.44 19.24 18.17 19.24 17.83V9.78Z"
            fill="#F8CA24"
        />
        <circle cx="19.2379" cy="9.77735" r="1.29981" fill="#F8CA24" />
        <circle cx="37.002" cy="9.77735" r="1.29981" fill="#F8CA24" />
        <circle cx="28.12" cy="8.47754" r="1.29981" fill="#F8CA24" />
        <ellipse
            cx="28.1199"
            cy="14.4396"
            rx="1.22182"
            ry="1.62909"
            fill={GuideColors.darkPurple}
        />
    </svg>
);

const BucketHatGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_28260"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_28260)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_28260"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_28260)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.64 18.24V15.88C12.64 13.19 14.83 11 17.53 11H38.47C41.17 11 43.36 13.19 43.36 15.88V17.9L46 23.00H10L12.64 18.24Z"
            fill="#5BA26F"
        />
        <circle cx="36.2373" cy="16.0846" r="1.22034" fill="#0F3B21" />
        <circle cx="40.5085" cy="16.0846" r="1.22034" fill="#0F3B21" />
        <mask
            id="mask2_14505_28260"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="10"
            y="11"
            width="36"
            height="12"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.64 18.24V15.88C12.64 13.19 14.83 11 17.53 11H38.47C41.17 11 43.36 13.19 43.36 15.88V17.9L46 23.00H10L12.64 18.24Z"
                fill="#5BA26F"
            />
        </mask>
        <g mask="url(#mask2_14505_28260)">
            <path
                d="M10.61 18.93H45.19"
                stroke="#0F3B21"
                strokeWidth="1.42373"
            />
        </g>
    </svg>
);

const GraduationCapGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_28488"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_28488)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_28488"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_28488)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path d="M47.26 12.79V22.77" stroke="#FCB500" strokeWidth="1.22182" />
        <rect
            x="16.3092"
            y="13.2012"
            width="24.4364"
            height="6.51636"
            fill="#010B1C"
        />
        <path
            d="M28.40 6.87L48.08 12.79L28.40 18.72L8.73 12.79L28.40 6.87Z"
            fill="#0B2149"
        />
        <path d="M44.21 23.59H50.32" stroke="#FCB500" strokeWidth="1.22182" />
        <path
            d="M47.26 20.53L47.26 26.64"
            stroke="#FCB500"
            strokeWidth="1.22182"
        />
        <path
            d="M45.10 21.42L49.42 25.74"
            stroke="#FCB500"
            strokeWidth="1.22182"
        />
        <path
            d="M49.42 21.42L45.10 25.74"
            stroke="#FCB500"
            strokeWidth="1.22182"
        />
    </svg>
);

const GlassesGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_28710"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_28710)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_28710"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_28710)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle
            cx="21.3651"
            cy="28.9748"
            r="6.78219"
            stroke="#F46A37"
            strokeWidth="2.05521"
        />
        <circle
            cx="35.1349"
            cy="28.7693"
            r="6.57667"
            stroke="#F46A37"
            strokeWidth="2.05521"
        />
        <path d="M14.44 28.69H11.50" stroke="#F46A37" strokeWidth="2.94043" />
        <path d="M45.00 28.69H42.06" stroke="#F46A37" strokeWidth="2.94043" />
    </svg>
);

const CowboyHatGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_28919"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_28919)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_28919"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_28919)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M22.40 7.62L19.42 13.94C26.97 19.24 34.23 16.15 36.92 13.94L33.33 7.54C32.49 6.05 30.51 5.68 29.19 6.76L28.15 7.61C28.11 7.65 28.05 7.65 28.01 7.62L26.45 6.54C25.05 5.57 23.12 6.08 22.40 7.62Z"
            fill="#725622"
            stroke="#725622"
            strokeWidth="0.597185"
            strokeLinecap="square"
        />
        <path
            d="M42.90 13.89C45.06 11.87 42.29 9.53 39.50 10.52C35.98 11.77 31.97 12.48 27.71 12.48C23.46 12.48 19.45 11.77 15.93 10.52C13.14 9.53 10.36 11.87 12.53 13.89C16.25 17.36 21.68 19.55 27.71 19.55C33.75 19.55 39.17 17.36 42.90 13.89Z"
            fill="#725622"
        />
        <mask
            id="mask2_14505_28919"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="19"
            y="5"
            width="19"
            height="13"
        >
            <path
                d="M22.40 7.62L19.42 13.94C26.97 19.24 34.23 16.15 36.92 13.94L33.33 7.54C32.49 6.05 30.51 5.68 29.19 6.76L28.15 7.61C28.11 7.65 28.05 7.65 28.01 7.62L26.45 6.54C25.05 5.57 23.12 6.08 22.40 7.62Z"
                fill="#614613"
                stroke="#614613"
                strokeWidth="0.597185"
                strokeLinecap="square"
            />
        </mask>
        <g mask="url(#mask2_14505_28919)">
            <path
                d="M48.69 6.52C43.84 10.73 36.25 13.44 27.71 13.44C19.18 13.44 11.58 10.73 6.74 6.52"
                stroke="#DAB773"
                strokeWidth="2.64727"
            />
        </g>
    </svg>
);

const BeretGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_28943"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_28943)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_28943"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_28943)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            d="M43.29 22.68C44.66 22.84 46.09 22.21 46.35 20.85C46.38 20.69 46.40 20.53 46.42 20.37C47.00 14.74 39.47 9.25 29.58 8.12C19.70 6.98 11.21 10.62 10.63 16.25C10.61 16.41 10.60 16.57 10.59 16.74C10.56 18.12 11.83 19.06 13.20 19.22L43.29 22.68Z"
            fill="#F46A37"
        />
        <path
            d="M29.64 10.39L33.43 7.18"
            stroke="#AC4343"
            strokeWidth="1.68727"
        />
    </svg>
);

const PartyHatGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14505_29144"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14505_29144)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14505_29144"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14505_29144)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <mask
            id="mask2_14505_29144"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="12"
            y="13"
            width="32"
            height="32"
        >
            <path
                d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
                fill="#DEAE93"
            />
        </mask>
        <g mask="url(#mask2_14505_29144)">
            <path
                d="M11.60 18.00L43.60 18.00"
                stroke="#F4EEE2"
                strokeWidth="1.2"
            />
        </g>
        <path
            d="M27.5 6.31L34 18.71H21L27.5 6.31Z"
            fill={GuideColors.darkPurple}
        />
        <mask
            id="mask3_14505_29144"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="21"
            y="6"
            width="13"
            height="13"
        >
            <path
                d="M27.5 6.31L34 18.71H21L27.5 6.31Z"
                fill={GuideColors.darkPurple}
            />
        </mask>
        <g mask="url(#mask3_14505_29144)">
            <path
                d="M29.02 9.21L22.08 15.68"
                stroke="#F4EEE2"
                strokeLinecap="square"
            />
            <path
                d="M32.93 10.06L21.01 21.02"
                stroke="#F4EEE2"
                strokeLinecap="square"
            />
            <path
                d="M35.35 12.47L23.43 23.42"
                stroke="#F4EEE2"
                strokeLinecap="square"
            />
        </g>
        <path d="M24.40 6.32H30.40" stroke="#F46A37" />
        <path d="M27.40 3.31L27.40 9.31" stroke="#F46A37" />
        <path d="M25.28 4.19L29.52 8.44" stroke="#F46A37" />
        <path d="M29.52 4.19L25.28 8.44" stroke="#F46A37" />
        <path
            d="M27.44 40.20C26.87 41.16 25.72 43.55 25.72 45.50M27.44 40.34H23.12C22.50 40.34 22 40.84 22 41.46V41.46C22 42.31 22.91 42.85 23.66 42.44L27.44 40.34Z"
            stroke="#F4EEE2"
            strokeWidth="1.2"
        />
        <path
            d="M27.16 40.20C27.73 41.16 28.88 43.55 28.88 45.50M27.16 40.34H31.48C32.10 40.34 32.6 40.84 32.6 41.46V41.46C32.6 42.31 31.69 42.85 30.94 42.44L27.16 40.34Z"
            stroke="#F4EEE2"
            strokeWidth="1.2"
        />
    </svg>
);

const ReindeerGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 13.88H38.45C41.22 13.88 43.47 16.13 43.47 18.89V41.57C43.47 43.76 40.86 44.90 39.25 43.41L37.57 41.85C37.10 41.42 36.49 41.18 35.86 41.18H15.11C13.72 41.18 12.6 40.05 12.6 38.67V18.89C12.6 16.13 14.85 13.88 17.61 13.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_16291_108523"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_16291_108523)">
            <circle cx="16.8" cy="26.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_16291_108523"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="22"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="28.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_16291_108523)">
            <circle cx="29.96" cy="26.492" r="6.16" fill="black" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.41 29.75C26.38 29.75 26.35 29.76 26.32 29.76L26.31 29.74C26.27 29.74 26.26 29.74 26.24 29.74C26.15 29.75 26.12 29.81 26.09 29.88C26.07 29.91 26.05 29.95 26.02 29.98C26.01 29.93 26.01 29.89 26.00 29.85C25.94 29.86 25.90 29.90 25.90 29.96C25.87 29.97 25.84 29.98 25.81 29.99C25.77 30.00 25.73 30.02 25.69 30.04L25.67 30.07C25.66 30.11 25.65 30.14 25.64 30.18C25.57 30.20 25.51 30.21 25.44 30.23L25.46 30.27C25.48 30.30 25.49 30.31 25.49 30.34C25.43 30.36 25.36 30.38 25.29 30.41L25.23 30.43C25.24 30.42 25.23 30.43 25.23 30.43L25.23 30.47C25.22 30.48 25.20 30.49 25.19 30.49L25.19 30.49C25.16 30.50 25.13 30.51 25.12 30.53C25.10 30.56 25.08 30.59 25.07 30.63C25.06 30.65 25.06 30.66 25.05 30.68C25.03 30.68 25.00 30.69 24.96 30.70C24.94 30.83 24.86 30.92 24.76 31.00C24.75 31.01 24.74 31.02 24.73 31.03L24.73 31.03L24.73 31.03C24.71 31.04 24.69 31.06 24.68 31.07L24.67 31.07C24.64 31.10 24.63 31.10 24.61 31.11C24.54 31.17 24.55 31.24 24.55 31.30C24.55 31.35 24.56 31.39 24.54 31.43C24.53 31.40 24.51 31.38 24.50 31.37C24.49 31.35 24.48 31.34 24.47 31.33C24.42 31.37 24.41 31.42 24.44 31.47C24.41 31.51 24.38 31.55 24.36 31.58C24.34 31.61 24.32 31.63 24.30 31.65C24.31 31.68 24.31 31.70 24.32 31.72C24.32 31.75 24.33 31.77 24.34 31.80C24.31 31.83 24.29 31.85 24.27 31.88C24.25 31.90 24.23 31.92 24.21 31.95C24.25 31.97 24.27 31.99 24.30 32.00C24.26 32.05 24.23 32.10 24.20 32.15C24.18 32.17 24.16 32.20 24.14 32.23C24.14 32.22 24.14 32.23 24.14 32.23C24.15 32.24 24.16 32.26 24.16 32.26C24.15 32.27 24.14 32.29 24.14 32.30C24.12 32.32 24.10 32.35 24.10 32.37C24.10 32.40 24.11 32.44 24.11 32.47C24.12 32.49 24.12 32.51 24.13 32.53C24.11 32.54 24.09 32.57 24.06 32.60C24.11 32.71 24.11 32.83 24.07 32.95C24.06 32.99 24.05 33.03 24.04 33.08L24.04 33.08L24.03 33.09L24.03 33.09C24.02 33.12 24.02 33.13 24.01 33.15C23.98 33.24 24.03 33.29 24.07 33.34C24.10 33.37 24.12 33.40 24.13 33.45C24.10 33.43 24.07 33.43 24.05 33.42L24.05 33.42L24.02 33.41C24.00 33.48 24.02 33.52 24.08 33.54L24.07 33.78C24.10 33.80 24.13 33.83 24.17 33.87L24.18 33.88C24.18 33.93 24.17 33.98 24.16 34.04L24.16 34.04L24.16 34.04L24.16 34.04L24.16 34.04L24.16 34.05L24.16 34.05L24.16 34.05L24.16 34.05L24.16 34.05L24.16 34.05L24.16 34.07L24.27 34.06C24.26 34.12 24.27 34.19 24.27 34.25C24.27 34.28 24.27 34.31 24.27 34.34C24.26 34.33 24.27 34.34 24.27 34.34C24.28 34.35 24.29 34.35 24.29 34.35C24.30 34.35 24.30 34.36 24.31 34.36C24.31 34.37 24.31 34.38 24.31 34.40L24.31 34.40C24.31 34.43 24.31 34.46 24.32 34.48C24.34 34.51 24.36 34.53 24.39 34.55C24.40 34.57 24.42 34.58 24.43 34.59C24.43 34.60 24.43 34.61 24.43 34.63C24.42 34.65 24.42 34.67 24.42 34.69C24.48 34.72 24.51 34.76 24.55 34.81C24.58 34.85 24.60 34.91 24.63 34.97C24.64 35.01 24.66 35.05 24.67 35.09L24.68 35.09L24.67 35.10C24.67 35.11 24.68 35.12 24.68 35.13C24.68 35.15 24.68 35.15 24.68 35.17C24.72 35.26 24.78 35.27 24.84 35.29C24.88 35.3 24.92 35.31 24.96 35.34L24.92 35.35C24.89 35.36 24.87 35.37 24.85 35.37C24.87 35.44 24.91 35.46 24.96 35.45L25.09 35.64C25.13 35.65 25.18 35.66 25.23 35.66L25.24 35.67C25.27 35.72 25.29 35.77 25.32 35.83L25.33 35.83L25.33 35.83C25.36 35.80 25.38 35.78 25.41 35.76C25.44 35.82 25.47 35.87 25.51 35.92L25.51 35.92L25.51 35.92L25.51 35.92L25.51 35.92C25.52 35.95 25.54 35.97 25.55 35.99C25.55 35.99 25.55 35.99 25.56 35.99C25.56 35.99 25.57 35.99 25.58 35.99L25.58 35.99C25.58 35.98 25.59 35.98 25.59 35.98C25.60 35.99 25.61 36.00 25.62 36.01C25.63 36.04 25.65 36.06 25.67 36.08C25.70 36.09 25.73 36.10 25.77 36.10L25.77 36.10C25.78 36.10 25.80 36.10 25.82 36.11L25.83 36.13L25.83 36.13C25.84 36.15 25.85 36.17 25.86 36.19C25.93 36.19 25.98 36.20 26.03 36.22C26.08 36.24 26.13 36.28 26.18 36.31C26.20 36.33 26.22 36.34 26.24 36.35L26.24 36.35L26.24 36.35C26.26 36.36 26.27 36.37 26.29 36.38L26.29 36.38L26.29 36.39C26.32 36.42 26.33 36.43 26.34 36.45C26.41 36.50 26.47 36.48 26.53 36.46C26.57 36.45 26.61 36.43 26.65 36.44L26.58 36.53C26.63 36.58 26.68 36.58 26.71 36.54L26.76 36.56L26.76 36.56L26.77 36.56C26.81 36.58 26.86 36.61 26.92 36.63C26.95 36.61 27.00 36.59 27.05 36.57C27.07 36.59 27.10 36.60 27.12 36.62L27.12 36.62L27.13 36.62L27.13 36.62L27.13 36.62C27.15 36.64 27.18 36.65 27.21 36.67C27.22 36.64 27.23 36.62 27.23 36.60L27.25 36.56C27.27 36.57 27.29 36.59 27.31 36.60C27.37 36.63 27.42 36.66 27.49 36.69C27.48 36.69 27.49 36.69 27.49 36.69C27.50 36.68 27.50 36.67 27.51 36.67L27.51 36.66C27.53 36.66 27.54 36.67 27.55 36.67L27.55 36.67L27.55 36.67C27.57 36.69 27.60 36.70 27.63 36.70C27.66 36.70 27.69 36.69 27.72 36.67C27.74 36.67 27.75 36.66 27.77 36.65C27.78 36.67 27.81 36.68 27.83 36.70L27.85 36.71C27.95 36.63 28.06 36.63 28.18 36.65L28.21 36.66L28.21 36.66C28.24 36.66 28.27 36.66 28.31 36.66L28.31 36.66L28.31 36.66C28.35 36.67 28.36 36.67 28.38 36.68C28.47 36.70 28.52 36.65 28.56 36.60C28.59 36.57 28.61 36.54 28.65 36.52C28.64 36.55 28.64 36.57 28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59L28.64 36.59C28.63 36.61 28.63 36.62 28.63 36.64C28.69 36.65 28.73 36.62 28.75 36.57C28.77 36.57 28.80 36.56 28.83 36.56C28.88 36.56 28.92 36.56 28.97 36.55C28.99 36.52 29.02 36.49 29.04 36.45L29.06 36.43L29.09 36.43L29.09 36.43C29.14 36.43 29.19 36.44 29.25 36.44C29.24 36.39 29.23 36.36 29.23 36.33C29.31 36.32 29.40 36.32 29.49 36.31C29.49 36.31 29.50 36.31 29.50 36.31C29.50 36.30 29.50 36.28 29.51 36.28L29.51 36.28L29.51 36.27C29.52 36.27 29.53 36.27 29.54 36.27L29.54 36.27C29.57 36.27 29.60 36.26 29.63 36.25C29.65 36.23 29.67 36.20 29.69 36.17C29.70 36.16 29.71 36.15 29.72 36.13L29.74 36.13L29.74 36.13C29.76 36.13 29.79 36.14 29.82 36.14C29.87 36.03 29.96 35.96 30.08 35.92C30.09 35.91 30.10 35.91 30.12 35.90L30.12 35.90L30.12 35.90L30.12 35.90L30.12 35.90L30.12 35.90L30.12 35.90L30.12 35.90C30.14 35.89 30.17 35.88 30.20 35.86L30.20 35.86L30.20 35.86C30.24 35.85 30.25 35.85 30.27 35.85C30.36 35.81 30.37 35.74 30.38 35.68C30.39 35.64 30.40 35.60 30.42 35.56C30.44 35.61 30.45 35.64 30.47 35.67C30.53 35.65 30.55 35.60 30.53 35.55C30.57 35.52 30.61 35.50 30.65 35.47C30.67 35.45 30.69 35.43 30.72 35.42C30.72 35.38 30.72 35.35 30.72 35.31L30.72 35.31L30.73 35.27L30.79 35.23C30.82 35.21 30.85 35.19 30.89 35.17C30.87 35.15 30.86 35.13 30.84 35.12L30.84 35.12L30.84 35.12C30.84 35.10 30.83 35.10 30.82 35.09C30.87 35.05 30.93 35.01 30.98 34.97L30.98 34.97L30.98 34.97L30.98 34.97L31.04 34.92C31.04 34.92 31.04 34.92 31.04 34.92C31.04 34.91 31.03 34.90 31.03 34.89C31.03 34.89 31.03 34.88 31.03 34.88C31.04 34.87 31.05 34.86 31.06 34.86C31.09 34.84 31.11 34.82 31.12 34.80C31.13 34.76 31.13 34.73 31.13 34.69C31.14 34.67 31.14 34.66 31.14 34.64C31.15 34.64 31.16 34.63 31.17 34.62L31.17 34.62L31.17 34.62C31.19 34.61 31.20 34.60 31.22 34.59C31.20 34.47 31.25 34.36 31.32 34.26C31.33 34.24 31.33 34.23 31.34 34.22C31.36 34.19 31.38 34.17 31.39 34.14L31.39 34.14L31.08 34.04L31.08 34.03L31.39 34.14L31.39 34.13C31.42 34.10 31.42 34.10 31.44 34.08C31.49 34.00 31.46 33.94 31.44 33.88C31.42 33.84 31.41 33.80 31.41 33.76L31.43 33.78L31.43 33.78C31.46 33.80 31.48 33.81 31.50 33.83C31.54 33.77 31.54 33.72 31.49 33.69C31.51 33.63 31.53 33.58 31.55 33.52L31.55 33.52L31.55 33.52L31.57 33.47C31.55 33.44 31.54 33.41 31.52 33.38L31.52 33.38L31.52 33.38L31.52 33.38L31.52 33.38C31.51 33.37 31.50 33.35 31.49 33.34L31.50 33.32L31.50 33.32L31.50 33.32C31.52 33.27 31.54 33.22 31.57 33.16C31.52 33.15 31.49 33.14 31.46 33.13C31.49 33.08 31.50 33.02 31.52 32.95C31.53 32.93 31.54 32.90 31.55 32.87C31.55 32.88 31.55 32.87 31.55 32.87C31.54 32.86 31.53 32.85 31.52 32.85L31.52 32.85L31.52 32.84C31.52 32.83 31.52 32.82 31.53 32.80C31.54 32.77 31.55 32.74 31.54 32.72C31.54 32.69 31.52 32.66 31.50 32.62C31.49 32.61 31.48 32.59 31.47 32.58C31.48 32.57 31.49 32.54 31.50 32.52L31.50 32.52L31.51 32.49C31.46 32.45 31.44 32.39 31.42 32.34C31.41 32.28 31.40 32.22 31.40 32.16C31.40 32.11 31.39 32.07 31.39 32.02L31.39 32.02L31.39 32.02L31.40 32.00C31.40 31.97 31.40 31.96 31.40 31.95C31.40 31.85 31.34 31.82 31.28 31.78C31.25 31.76 31.21 31.74 31.19 31.70C31.24 31.70 31.27 31.70 31.31 31.70L31.31 31.70C31.31 31.63 31.27 31.59 31.22 31.59L31.19 31.51C31.18 31.46 31.17 31.42 31.15 31.37C31.11 31.35 31.07 31.33 31.01 31.31C31.00 31.25 30.99 31.19 30.98 31.12L30.98 31.12C30.93 31.14 30.91 31.15 30.87 31.16C30.86 31.10 30.84 31.03 30.82 30.96L30.82 30.96L30.82 30.96L30.82 30.96C30.81 30.94 30.80 30.92 30.80 30.90C30.80 30.90 30.80 30.89 30.79 30.89L30.76 30.89C30.75 30.88 30.75 30.87 30.74 30.85C30.73 30.82 30.72 30.80 30.71 30.78C30.68 30.76 30.65 30.74 30.62 30.73L30.62 30.73L30.62 30.73C30.60 30.72 30.59 30.71 30.57 30.71L30.57 30.68C30.56 30.66 30.56 30.64 30.55 30.61C30.49 30.60 30.44 30.57 30.40 30.54C30.35 30.50 30.32 30.46 30.28 30.41C30.26 30.38 30.24 30.36 30.22 30.34L30.23 30.33C30.23 30.32 30.22 30.31 30.22 30.30C30.21 30.28 30.20 30.28 30.20 30.26C30.14 30.19 30.07 30.19 30.00 30.19C29.96 30.19 29.91 30.20 29.87 30.18C29.89 30.16 29.91 30.15 29.93 30.14L29.93 30.14C29.95 30.13 29.96 30.12 29.97 30.11C29.93 30.05 29.88 30.04 29.83 30.07C29.77 30.02 29.72 29.98 29.65 29.92C29.61 29.93 29.55 29.94 29.50 29.95C29.45 29.90 29.41 29.86 29.36 29.81L29.34 29.84C29.32 29.86 29.30 29.88 29.29 29.90C29.23 29.84 29.16 29.78 29.07 29.72C29.07 29.72 29.07 29.72 29.07 29.72L29.07 29.72C29.06 29.73 29.04 29.74 29.04 29.74C29.03 29.73 29.02 29.73 29.00 29.72C28.98 29.70 28.96 29.68 28.93 29.67C28.89 29.66 28.86 29.67 28.81 29.68C28.80 29.68 28.78 29.68 28.77 29.68C28.76 29.67 28.74 29.65 28.72 29.63L28.72 29.63L28.72 29.63L28.72 29.63L28.70 29.61C28.58 29.66 28.47 29.62 28.36 29.58L28.34 29.58L28.30 29.57L28.30 29.57L28.31 29.51C28.27 29.48 28.26 29.48 28.25 29.46C28.17 29.42 28.11 29.46 28.06 29.50C28.02 29.53 27.99 29.55 27.95 29.56C27.97 29.51 27.98 29.48 27.99 29.45C27.93 29.42 27.89 29.43 27.86 29.48C27.81 29.46 27.76 29.46 27.71 29.45C27.69 29.45 27.67 29.44 27.64 29.44L27.63 29.45L27.63 29.45L27.63 29.45C27.60 29.47 27.57 29.50 27.53 29.53L27.50 29.52C27.45 29.50 27.41 29.49 27.35 29.47L27.35 29.51L27.35 29.51C27.35 29.54 27.35 29.56 27.34 29.59L27.27 29.57L27.27 29.57L27.27 29.57C27.21 29.56 27.15 29.54 27.08 29.53C27.09 29.52 27.08 29.52 27.08 29.53C27.07 29.54 27.06 29.55 27.06 29.56L27.06 29.56L27.06 29.56C27.05 29.56 27.03 29.56 27.02 29.56C26.99 29.55 26.96 29.55 26.94 29.56C26.91 29.57 26.88 29.58 26.85 29.61C26.84 29.62 26.83 29.63 26.81 29.64L26.78 29.63C26.77 29.62 26.75 29.61 26.72 29.61C26.64 29.71 26.54 29.74 26.41 29.75ZM29.07 29.72L29.08 29.72L29.07 29.72L29.07 29.72ZM31.04 34.92L31.04 34.92L31.04 34.92L31.04 34.92Z"
            fill="#F46A37"
        />
        <path
            d="M32.51 17.52C33.51 16.97 36.06 16.27 38.19 17.81C40.32 19.35 42.68 17.92 43.59 17.02"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
        <path
            d="M37.57 17.32C38.98 16.66 41.90 13.91 42.20 8.15"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
        <path
            d="M41.89 12.53C43.16 12.74 46.04 12.64 47.46 10.54"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
        <path
            d="M23.90 17.52C22.89 16.97 20.34 16.27 18.21 17.81C16.08 19.35 13.73 17.92 12.81 17.02"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
        <path
            d="M18.84 17.32C17.42 16.66 14.50 13.91 14.20 8.15"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
        <path
            d="M14.51 12.53C13.25 12.74 10.36 12.64 8.94 10.54"
            stroke="#816634"
            strokeWidth="2.25162"
            strokeLinecap="round"
        />
    </svg>
);

const FedoraShinyGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M12.6 22.88H43.47V43.57C43.47 45.76 40.86 46.90 39.25 45.41L37.57 43.85C37.10 43.42 36.49 43.18 35.86 43.18H15.11C13.72 43.18 12.6 42.05 12.6 40.67V22.88Z"
            fill="#DEAE93"
        />
        <circle cx="21.4179" cy="30.8578" r="6.01791" fill="white" />
        <mask
            id="mask0_14639_11860"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="15"
            y="24"
            width="13"
            height="13"
        >
            <circle cx="21.4179" cy="30.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask0_14639_11860)">
            <circle cx="16.8" cy="28.492" r="6.16" fill="black" />
        </g>
        <circle cx="34.578" cy="30.8578" r="6.01791" fill="white" />
        <mask
            id="mask1_14639_11860"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="28"
            y="24"
            width="13"
            height="13"
        >
            <circle cx="34.578" cy="30.8578" r="6.01791" fill="white" />
        </mask>
        <g mask="url(#mask1_14639_11860)">
            <circle cx="29.96" cy="28.492" r="6.16" fill="black" />
        </g>
        <path d="M9 23.20H47" stroke="black" strokeWidth="2.11111" />
        <path d="M9 23.20H47" stroke="black" strokeWidth="2.11111" />
        <path
            d="M16.97 13.31L13.01 22.14H43.41L42.38 15.49C41.79 11.69 37.77 9.46 34.23 10.96L30.38 12.59C30.28 12.63 30.16 12.63 30.05 12.59L24.69 10.29C21.73 9.02 18.29 10.36 16.97 13.31Z"
            fill="black"
            stroke="black"
            strokeWidth="1.05556"
            strokeLinecap="square"
            strokeLinejoin="round"
        />
        <mask
            id="mask2_14639_11860"
            style={{maskType: "alpha"}}
            maskUnits="userSpaceOnUse"
            x="12"
            y="9"
            width="32"
            height="14"
        >
            <path
                d="M16.97 13.31L13.01 22.14H43.41L42.38 15.49C41.79 11.69 37.77 9.46 34.23 10.96L30.38 12.59C30.28 12.63 30.16 12.63 30.05 12.59L24.69 10.29C21.73 9.02 18.29 10.36 16.97 13.31Z"
                fill="black"
                stroke="black"
                strokeWidth="1.05556"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </mask>
        <g mask="url(#mask2_14639_11860)">
            <rect
                x="12.1666"
                y="19.1885"
                width="32.7222"
                height="2.95556"
                fill="#F4EEE2"
            />
        </g>
        <path
            d="M14.25 5.58C14.33 5.38 14.62 5.38 14.70 5.58L15.60 7.94C15.62 8.00 15.67 8.05 15.73 8.07L17.71 8.97C17.90 9.06 17.90 9.32 17.71 9.41L15.73 10.31C15.67 10.34 15.62 10.38 15.60 10.44L14.70 12.80C14.62 13.00 14.33 13.00 14.25 12.80L13.35 10.44C13.33 10.38 13.28 10.34 13.23 10.31L11.25 9.41C11.06 9.32 11.06 9.06 11.25 8.97L13.23 8.07C13.28 8.05 13.33 8.00 13.35 7.94L14.25 5.58Z"
            fill="#FCB500"
            style={{transformOrigin: "14.48px 9.13px"}}
        >
            <animate
                attributeName="opacity"
                dur="1.1s"
                repeatCount="indefinite"
                values="0;1;0"
            />
            <animateTransform
                attributeName="transform"
                type="scale"
                dur="1.1s"
                begin="0s"
                repeatCount="indefinite"
                values="0.3;1;0.3"
            />
        </path>
        <path
            d="M6.65 14.45C6.73 14.24 7.02 14.24 7.10 14.45L7.64 15.85C7.66 15.91 7.71 15.96 7.76 15.98L8.95 16.52C9.13 16.61 9.13 16.87 8.95 16.96L7.76 17.50C7.71 17.52 7.66 17.57 7.64 17.63L7.10 19.03C7.02 19.24 6.73 19.24 6.65 19.03L6.12 17.63C6.09 17.57 6.05 17.52 5.99 17.50L4.81 16.96C4.62 16.87 4.62 16.61 4.81 16.52L5.99 15.98C6.05 15.96 6.09 15.91 6.12 15.85L6.65 14.45Z"
            fill="#FCB500"
            style={{transformOrigin: "6.88px 16.74px"}}
        >
            <animate
                attributeName="opacity"
                dur="1.1s"
                repeatCount="indefinite"
                values="0;0.5;1;0.5;0"
                begin="400ms"
            />
            <animateTransform
                attributeName="transform"
                type="scale"
                dur="1.1s"
                begin="400ms"
                repeatCount="indefinite"
                values="0;1;0"
            />
        </path>
        <path
            d="M46.90 13.02C46.98 12.82 47.27 12.82 47.35 13.02L47.88 14.43C47.91 14.49 47.95 14.53 48.01 14.56L49.19 15.10C49.38 15.18 49.38 15.45 49.19 15.53L48.01 16.07C47.95 16.10 47.91 16.15 47.88 16.20L47.35 17.61C47.27 17.81 46.98 17.81 46.90 17.61L46.36 16.20C46.34 16.15 46.29 16.10 46.24 16.07L45.05 15.53C44.87 15.45 44.87 15.18 45.05 15.10L46.24 14.56C46.29 14.53 46.34 14.49 46.36 14.43L46.90 13.02Z"
            fill="#FCB500"
            style={{transformOrigin: "47.12px 15.32px"}}
        >
            <animate
                attributeName="opacity"
                dur="1.1s"
                repeatCount="indefinite"
                values="1;0;1"
                begin="300ms"
            />
            <animateTransform
                attributeName="transform"
                type="scale"
                dur="1.1s"
                begin="300ms"
                repeatCount="indefinite"
                values="1;0;1"
            />
        </path>
    </svg>
);

const OfflineGuideIcon = ({title}): React.ReactElement => (
    <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {title && <title>{title}</title>}
        <circle cx="28" cy="28" r="28" fill={GuideColors.darkPurple} />
        <path
            d="M17.61 12.88H38.45C41.22 12.88 43.47 15.13 43.47 17.89V40.57C43.47 42.76 40.86 43.90 39.25 42.41L37.57 40.85C37.10 40.42 36.49 40.18 35.86 40.18H15.11C13.72 40.18 12.6 39.05 12.6 37.67V17.89C12.6 15.13 14.85 12.88 17.61 12.88Z"
            fill="#4CAEE5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.66 33.28C19.30 33.28 17.38 31.37 17.38 29.00H15.66C15.66 32.31 18.35 35 21.66 35C24.98 35 27.67 32.31 27.67 29.00H25.95C25.95 31.37 24.03 33.28 21.66 33.28Z"
            fill="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.83 33.28C32.46 33.28 30.54 31.37 30.54 29.00H28.82C28.82 32.31 31.51 35 34.83 35C38.14 35 40.83 32.31 40.83 29.00H39.11C39.11 31.37 37.19 33.28 34.83 33.28Z"
            fill="black"
        />
    </svg>
);
